export const isDemoMode = import.meta.env.VITE_DEMO_MODE === "true";
export const usesLocalData =
  isDemoMode || import.meta.env.VITE_USE_MOCK_API === "true";
